import React from 'react';

const NoMatch = () => {
    return (
        <div>
            <h1>404 Error. No Match Found.</h1>
        </div>
    );
};

export default NoMatch;